export default __webpack_public_path__ + "static/worldbuilder-3c3f56b1272284cdbe24022e33ffc535.jpg";